import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import LocalMall from '@material-ui/icons/LocalMall';
import { connect } from 'react-redux';
import FormatListNumbered from '@material-ui/icons/FormatListNumbered';
import { getSuperCategory as getCategoryList } from '../../store/actions/vendor/Vendor';
// core components
import GridItem from '../../components/Grid/GridItem.js';
import Card from '../../components/Card/Card.js';
import CardHeader from '../../components/Card/CardHeader.js';
import CardIcon from '../../components/Card/CardIcon.js';
import CardFooter from '../../components/Card/CardFooter.js';

import styles from '../../assets/jss/material-dashboard-react/views/dashboardStyle.js';

const useStyles = makeStyles(styles);

var update = false;
function SuperCategoriesVendor(props) {
  useEffect(() => {
    props.getCategoryList();
  }, [update]);

  const classes = useStyles();
  return (
    <GridItem xs={12} sm={6} md={3}>
      <Link style={{ textDecoration: 'none' }} to={'/vendor2/superCategories'}>
        <Card>
          <CardHeader color="warning" stats icon>
            <CardIcon color="warning">
              <FormatListNumbered />
            </CardIcon>
            <p className={classes.cardCategory}>Super-Categories</p>
            <h3 className={classes.cardTitle}>
              {props.superCategories.length}
            </h3>
          </CardHeader>
          <CardFooter stats>
            <div className={classes.stats}>
              <LocalMall />
              <a>List of superCategories added </a>
            </div>
          </CardFooter>
        </Card>
      </Link>
    </GridItem>
  );
}

const mapStateWithProps = (state) => ({
  superCategories: state.vendor.superCategories
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList())
  };
};

export default connect(
  mapStateWithProps,
  mapDispatchWithProps
)(SuperCategoriesVendor);
